module.exports = __webpack_public_path__ + "img/09_garnish.5b772548.png";